
import React, { useState } from "react";
import { Container, Row, Col, Form, Button,Image } from "react-bootstrap";
import man from "../../assets/DSC03537-removebg-preview 1.png";
import styles from "./Product.module.css"
import Navbar from "../../Navbar/Navbar";

export default function ProductLanding() {
  const [validated, setValidated] = useState(false);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    setValidated(true);
  };
  return (
    <div className={styles.ladningbg}>
      <Navbar/>
    <div className={styles.container}>
      <div className={styles.containerrow}>
        <div className={styles.containercol1}>
          <div style={{ width: "90%" }}>
            <h1 className={styles.headingoflanding}>
              Book your Home 
              Services in Minutes
            </h1>

            <div className={styles.formbox}>
              <Form noValidate validated={validated} onSubmit={handleSubmit} style={{marginTop:12}}>
                <Row className="mb-3">
                  <Form.Group as={Col} md="12" controlId="validationCustom01">
                    <Form.Control
                      required
                      type="text"
                      placeholder="Name"
                      className={styles.inputBox}
                      style={{background:"transparent",border:"none",borderBottom:"1px solid #767676",borderRadius:0,fontFamily:"sans-serif",fontSize:14}}
                    />
                  </Form.Group>
                </Row>

                <Row className="mb-3">
                  <Form.Group as={Col} md="12" controlId="validationCustom01">
                    <Form.Control
                      required
                      type="text"
                      placeholder="Phone"
                      style={{background:"transparent",border:"none",borderBottom:"1px solid #767676",borderRadius:0,fontFamily:"sans-serif",fontSize:14}}
                    />
                  </Form.Group>
                </Row>

                <Row className="mb-3">
                  <Form.Group as={Col} md="12" controlId="validationCustom01">
                    <Form.Control
                      required
                      type="text"
                      placeholder="Email"
                      style={{background:"transparent",border:"none",borderBottom:"1px solid #767676",borderRadius:0,fontFamily:"sans-serif",fontSize:14}}
                    />
                  </Form.Group>
                </Row>

                <Button type="submit" className={"mx-auto d-block"} style={{background:"#66d6ff",border:"none",fontFamily:"Inter"}} >Quick Booking</Button>
              </Form>
            </div>
          </div>
        </div>
        <div className={styles.containercol2}>
          <Image src={man} alt="men" className={styles.imggirl} />
        </div>
      </div>
    </div>
    </div>
  );
}

